<div class="doctors__item" [class.active]="isActive">
    <!-- Desktop version -->
    <ng-container *ngIf="!isMobile">
        <div class="doctor__item-img">
            <img
                class="doctors__img"
                src="{{ getImgSrcDoc(doctor.doctorid) }}"
                (error)="getDocImgDefault($event)"
                alt="doc"
            />
        </div>
        <div class="doctors__item-container">
            <div class="doctors__item-info">
                <div class="doctors__name">
                    {{ getFioDoc(doctor) }}
                    <button
                        type="button"
                        class="doctors__info"
                        (click)="openDocInfoModal(doctor, $event)"
                        title="Нажмите для получения информации о враче"
                        *ngIf="doctor.infoDoc && doctor.infoDoc.length > 0"
                    >
                        <img src="./assets/img/svg/info.svg" alt="info" />
                    </button>
                </div>
                <div
                    class="doctors__description"
                    *ngIf="doctor.infoDoc && doctor.infoDoc.length > 0"
                >
                    <div
                        class="doctors__description-text"
                        [title]="
                            experienceText(doctor.workExp) +
                            ' ' +
                            doctor.workSpec
                        "
                    >
                        {{ experienceText(doctor.workExp) }}
                        <span class="dot"> </span>
                        {{ doctor.workSpec }}
                    </div>
                </div>
            </div>
            <div class="doctors__right">
                <div
                    class="service-select"
                    [attr.data-doctor-id]="doctor.doctorid"
                >
                    <input
                        type="text"
                        class="select-trigger"
                        [placeholder]="
                            doctor.srvlist?.length === 0
                                ? 'Список пуст'
                                : selectedSrvMap[doctor.doctorid]
                                ? selectedSrvMap[doctor.doctorid].text
                                : 'Выберите услугу'
                        "
                        (focus)="toggleSelect(doctor.doctorid)"
                        #InputBlocServ
                        [(ngModel)]="searchStrSrv[doctor.doctorid]"
                        (ngModelChange)="
                            changeSearchSrv($event, doctor.doctorid)
                        "
                        [ngClass]="{
                            selected: !!selectedSrvMap[doctor.doctorid]
                        }"
                    />
                    <img
                        src="./assets/img/svg/dropdown_arrow.svg"
                        alt="dropdown_arrow"
                        width="16px"
                        height="16px"
                        class="dropdown-arrow"
                        [ngClass]="
                            openSelectStates[doctor.doctorid]
                                ? 'rotateArrow'
                                : ''
                        "
                        (click)="InputBlocServ.focus()"
                    />

                    <div
                        class="filter__dropdown-list"
                        *ngIf="
                            openSelectStates[doctor.doctorid] &&
                            doctor.srvlist?.length !== 0
                        "
                    >
                        <div
                            *ngFor="let docSrv of doctor.srvlist"
                            class="select-option"
                            (click)="selectService(docSrv, doctor)"
                        >
                            <div class="filter__option-container">
                                <div class="filter__option-left">
                                    <div class="srv-option__text">
                                        <span>{{ docSrv.text }}</span>
                                    </div>
                                </div>
                                <div class="filter__option-right">
                                    <button
                                        *ngIf="docSrv.description"
                                        class="doc-info-btn"
                                        (click)="
                                            openServDescModal(docSrv, $event)
                                        "
                                    >
                                        <img src="./assets/img/svg/info.svg" />
                                    </button>
                                    <div class="srv-option__price-container">
                                        <div class="srv-option__price">
                                            <span *ngIf="docSrv.price != 0"
                                                >{{ docSrv.price }} руб.</span
                                            >
                                            <span *ngIf="docSrv.price == 0"
                                                >Бесплатно</span
                                            >
                                        </div>
                                        <div
                                            *ngIf="docSrv.is_online_pay == 1"
                                            class="srv-option__price-icon"
                                        >
                                            <img
                                                src="./assets/img/svg/rub.svg"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="doctors__rcount">
                    {{ rcountText(doctor.rcount) }}
                </div>
            </div>
        </div>
    </ng-container>

    <!-- Mobile version -->
    <ng-container *ngIf="isMobile">
        <div class="doctor__card">
            <div class="doctor__card-top">
                <img
                    class="doctor__img"
                    src="{{ getImgSrcDoc(doctor.doctorid) }}"
                    (error)="getDocImgDefault($event)"
                    alt="doc"
                    width="48"
                    height="48"
                    border-radius="5px"
                />
                <div class="doctor__desc">
                    <div class="doctor__name">
                        {{ getFioDoc(doctor) }}
                    </div>
                    <div class="doctor__desc-rcount">
                        {{ rcountText(doctor.rcount) }}
                    </div>
                </div>
            </div>
            <!-- (click)="showSrvHandler($event, doctor)" -->
            <button
                class="doctor__serv-button"
                [disabled]="!doctor.srvlist || doctor.srvlist.length === 0"
                (click)="pickDoctorHandler(doctor)"
            >
                {{
                    doctor.srvlist && doctor.srvlist.length > 0
                        ? "Выберите услугу"
                        : "Нет доступных услуг"
                }}
            </button>
        </div>
    </ng-container>
</div>
